const post = async (appState, route, body) => {
  return fetch(`${appState.apiv2}/${route}`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      'Content-type': 'application/json'
    },
    cache: "default",
    credentials: "include"
  })
    .then(function (response) {
      return response.json();
    })
};

const get = async (appState, route) => {
  return fetch(`${appState.apiv2}/${route}`, {
    method: "GET",
    cache: "default",
    credentials: "include"
  })
    .then(function (response) {
      return response.json();
    })
};

export const createTask = (appState, body) => post(appState, 'task/create', body);

export const updateTask = (appState, body) => post(appState, 'task/update', body);

export const getTaskList = (appState) => get(appState, 'task/list/me');

export const getUserList = (appState) => get(appState, 'user/list');



// WEBPACK FOOTER //
// ./src/apiv2/index.js